import React, { useRef, useState, useEffect } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  EquipmentIcon,
  ApparelIcon,
  AccessoriesIcon,
  AddIconBlue,
} from "../../../../constant/imagePath";
import { Container, ModalTitle } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./SetYourLessonMobile.module.css";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { InputWithButton } from "../../../../stories/InputWithButton/InputWithButton";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Tabs } from "../../../../stories/Tabs/Tabs";
import AddEquipmentModal from "../../../Modals/CoachFlow/OnBoarding/AddEquipment/AddEquipment";
import { CommonQuestions } from "../../../../stories/CommonQuestions/CommonQuestions";
import accordionCss from "../../../../stories/CommonQuestions/commonQuestions.module.css";
import { Sleep } from "../../../../util/CustomFunctions";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

export default function SetYourLessonMobile({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );

  const [sessionPlan, setSessionPlan] = useState(
    getDataFromRedux?.sessionPlan ? getDataFromRedux?.sessionPlan : ""
  );
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [sectionTitle, setSectionTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  //  Provide states
  const [renderEquipments, setRenderEquipments] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderEquipments
      : [
        { label: "Grips", value: "Grips", isChecked: "" },
        { label: "Racquet string", value: "Racquet string", isChecked: "" },
        { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
        { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
      ]
  );
  const [renderApparels, setRenderApparels] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderApparels
      : [
        { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
        { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
        { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
        { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
        { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
        { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
      ]
  );
  const [renderAccessories, setRenderAccessories] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderAccessories
      : [
        { label: "Water", value: "Water", isChecked: "" },
        { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
        {
          label: "Hair ties/Headband",
          value: "Hair ties/Headband",
          isChecked: "",
        },
        { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
        { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
      ]
  );
  //  Bring states
  const [renderEquipmentsForBring, setRenderEquipmentsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderEquipmentsForBring
      : [
        { label: "Grips", value: "Grips", isChecked: "" },
        { label: "Racquet string", value: "Racquet string", isChecked: "" },
        { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
        { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
      ]
  );
  const [renderApparelsForBring, setRenderApparelsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderApparelsForBring
      : [
        { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
        { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
        { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
        { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
        { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
        { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
      ]
  );
  const [renderAccessoriesForBring, setRenderAccessoriesForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderAccessoriesForBring
      : [
        { label: "Water", value: "Water", isChecked: "" },
        { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
        {
          label: "Hair ties/Headband",
          value: "Hair ties/Headband",
          isChecked: "",
        },
        { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
        { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
      ]
  );

  //
  function onAdd() {
    if (sectionTitle === "what will you provide?") {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipments(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparels(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessories(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipmentsForBring(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparelsForBring(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessoriesForBring(newArr);
      }
    }
  }

  useEffect(() => {
    if (sectionTitle === "what will you provide?") {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipments];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparels];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessories];
        setModalData(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipmentsForBring];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparelsForBring];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessoriesForBring];
        setModalData(newArr);
      }
    }
  }, [showEquipmentModal]);

  console.log("aaaa", sectionTitle);

  const willProvide = [
    {
      title: "Equipment",
      state: renderEquipments,
      setter: setRenderEquipments,
    },
    { title: "Apparel", state: renderApparels, setter: setRenderApparels },
    {
      title: "Accessories",
      state: renderAccessories,
      setter: setRenderAccessories,
    },
  ];
  const shouldBring = [
    {
      title: "Equipment",
      state: renderEquipmentsForBring,
      setter: setRenderEquipmentsForBring,
    },
    {
      title: "Apparel",
      state: renderApparelsForBring,
      setter: setRenderApparelsForBring,
    },
    {
      title: "Accessories",
      state: renderAccessoriesForBring,
      setter: setRenderAccessoriesForBring,
    },
  ];

  function saveDataIntoRedux() {
    dispatch(
      setPersonalData("set-lesson", {
        provide: { renderEquipments, renderApparels, renderAccessories },
        bring: {
          renderEquipmentsForBring,
          renderApparelsForBring,
          renderAccessoriesForBring,
        },
        sessionPlan,
      })
    );
  }

  return (
    <div className={classes.setYourLesson}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <style jsx>{`
        .${accordionCss.customAccordion} button:focus {
          color: ${Colors.mainBlue} !important;
        }
      `}</style>
      <Row className={`g-0 ${classes.innerContainer}`}>
        <Col md={12}>
          <h3
            style={{
              ...Fonts.h3,
              color: Colors.neutralShadesOfNero,
              fontSize: "24px",
              lineHeight: "32px",
              fontWeight: 400,
            }}
          >
            Set Your Lesson
          </h3>

          <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
            1-on-1 lesson
          </p>
        </Col>

        <Col md={12} className={`${[classes.mb56, classes.mt32].join(" ")}`}>
          <TextArea
            label={"Tell students about your session plan"}
            textAreaStyle={{ minHeight: "112px", maxHeight: "112px" }}
            placeholder="What will you cover in the lesson? What should students expect?"
            setter={setSessionPlan}
            state={sessionPlan}
          />
        </Col>
        <Col md={12} className={classes.mb24}>
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            What will you provide?
          </h4>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            Select the things you can provide for your future students.
          </p>
        </Col>

        <Col md={12}>
          <CommonQuestions
            padding={"24px 0px"}
            data={willProvide?.map((item) => ({
              title: (
                <div className={classes.spaceBetween}>
                  <span
                    style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
                  >
                    {item?.title}
                  </span>
                  <span>
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle(item?.title);
                        setSectionTitle("what will you provide?");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </span>
                </div>
              ),
              description: (
                <ul className={classes.checkboxList}>
                  {item?.state.map((check, i) => {
                    return (
                      <li>
                        <Checkbox
                          label={check.label}
                          checked={check?.label == check?.isChecked}
                          onClick={(e) => {
                            const newArr = [...item?.state];
                            if (newArr[i].isChecked !== check?.label) {
                              newArr[i].isChecked = check?.label;
                            } else {
                              newArr[i].isChecked = "";
                            }
                            item?.setter(newArr);
                          }}
                        />
                      </li>
                    );
                  })}
                </ul>
              ),
            }))}
          />
        </Col>
        <Col md={12} className={`${[classes.mb24, classes.mt56].join(" ")}`}>
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
              color: Colors.neutralShadesOfNero,
            }}
          >
            What student should bring?
          </h4>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            Select the things that the student should take to your lesson.
          </p>
        </Col>
        <Col md={12}>
          <CommonQuestions
            padding={"24px 0px"}
            data={shouldBring?.map((item) => ({
              title: (
                <div className={classes.spaceBetween}>
                  <span
                    style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
                  >
                    {item?.title}
                  </span>
                  <span>
                    <LinkButtonWithIcon
                      text={"Add item"}
                      leftIcon={AddIconBlue}
                      primary={true}
                      customStyle={{
                        ...Fonts.b2,
                        lineHeight: "20px",
                      }}
                      iconStyle={{
                        marginRight: "4px",
                        width: "16px",
                        height: "16px",
                      }}
                      onClick={() => {
                        setModalTitle(item?.title);
                        setSectionTitle("what student should bring?");
                        setShowEquipmentModal(true);
                      }}
                    />
                  </span>
                </div>
              ),
              description: (
                <ul className={classes.checkboxList}>
                  {item?.state.map((check, i) => {
                    return (
                      <li>
                        <Checkbox
                          label={check.label}
                          checked={check?.label == check?.isChecked}
                          onClick={(e) => {
                            const newArr = [...item?.state];
                            if (newArr[i].isChecked !== check?.label) {
                              newArr[i].isChecked = check?.label;
                            } else {
                              newArr[i].isChecked = "";
                            }
                            item?.setter(newArr);
                          }}
                        />
                      </li>
                    );
                  })}
                </ul>
              ),
            }))}
          />
        </Col>
      </Row>

      {/* Buttons Row */}
      <Row className="g-0">
        <Col lg={12}>
          <div
            className={classes.btnsBox}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
          >
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                width: "max-content",
                height: "56px",
              }}
              onClick={() => stepForwardAndBackward(1, 2)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ ...Fonts.b1, width: "162px", height: "56px" }}
              onClick={() => {
                saveDataIntoRedux();
                stepForwardAndBackward(2, 2);
              }}
            />
          </div>
        </Col>
      </Row>
      {/* Add Equipment Modal */}
      <AddEquipmentModal
        show={showEquipmentModal}
        setShow={setShowEquipmentModal}
        title={modalTitle}
        onAdd={onAdd}
        setter={setModalData}
        state={modalData}
        options={["avbc", "cass"]}
      />
    </div>
  );
}
